import BfiToOrderTable from './tables/BfiToOrderTable';
import OrderedTable from './tables/OrderedTable';
import ReceivedTable from './tables/ReceivedTable';
import ReviewedTable from './tables/ReviewedTable';
import { SectionHeader, BfiCustomStore } from '../../common/SharedComponents';
import store, { searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import AppraisalModal from './modals/AppraisalModal';
import DeclineOrRecycleModal from '../common/modals/DeclineOrRecycleModal';
import ApplicationReviewModal from '../submitted/modals/ApplicationReviewModal';
import RollbackModal from '../common/modals/RollbackModal';
import debounce from 'lodash.debounce';
import ConvertToLoanModal from './modals/ConvertToLoanModal';
import MovePropertiesModal from '../common/modals/MovePropertiesModal';
import AuditHistoryModal from '../common/modals/AuditHistoryModal';
import PrincipalSwapModal from '../common/modals/PrincipalSwapModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { ApplicationFilesModal } from '../common/modals/ApplicationFilesModal';

function AppraiseAppsLanding() {
    const searchState = useSelector((state) => state.searchState);

    const { dispatch } = store;

    const debouncedSearch = debounce(dispatch, 500);
    const bfiToOrderGridStore = new BfiCustomStore();
    const orderedGridStore = new BfiCustomStore();
    const receivedGridStore = new BfiCustomStore();
    const reviewedGridStore = new BfiCustomStore();

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    appraise: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader title='Appraise' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search on BFI Number, City, State, Borrower or User...'
                        defaultValue={searchState?.searchText?.appraise}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <div
                        className='accordion applications'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <BfiToOrderTable gridStore={bfiToOrderGridStore} />
                    </div>
                    <div
                        className='accordion applications'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <OrderedTable gridStore={orderedGridStore} />
                    </div>
                    <div
                        className='accordion applications'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <ReceivedTable gridStore={receivedGridStore} />
                    </div>
                    <div
                        className='accordion applications'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <ReviewedTable gridStore={reviewedGridStore} />
                    </div>
                </div>
            </div>
            <ApplicationReviewModal />
            <AppraisalModal />
            <RollbackModal />
            <DeclineOrRecycleModal />
            <ConvertToLoanModal />
            <MovePropertiesModal />
            <AuditHistoryModal />
            <PrincipalSwapModal />
            <ApplicationFilesModal />
        </>
    );
}

export default AppraiseAppsLanding;
